<aside id="left-panel">

  <nav *ngIf="reloadNav">
    <ng-container *ngIf="!isNavLoading">
      <ul saSmartMenu class="navigationMenu">
        <li *ngFor="let node of navigationList" routerLinkActive="active">
          <a *ngIf="node.children.length > 0" (click)="setNavid(node.ID,node.MODULE,'',node)" href="#" class="primary-font"
            title="{{node.LABEL}}">
            <i class="fa fa-lg fa-fw {{node.ICON}}"></i>
            <span class="menu-item-parent menuTooltip primary-font">{{node.LABEL}}</span>
          </a>
          <a *ngIf="node.children.length === 0" (click)="setNavid(node.ID,node.MODULE,'',node)" routerLink="{{node.MODULE}}"
            class="primary-font" title="{{node.LABEL}}">
            <i class="fa fa-lg fa-fw {{node.ICON}}"></i>
            <span class="menu-item-parent menuTooltip primary-font">{{node.LABEL}}</span>
          </a>
          <ul *ngIf="node.children.length > 0">
            <li *ngFor="let child of node.children" routerLinkActive="active">
              <a *ngIf="child.children.length > 0" (click)="setNavid(child.ID,child.MODULE,'',node)" href="#"
                class="primary-font" title="{{child.LABEL}}">
                <span>{{child.LABEL}}</span>
              </a>
              <a *ngIf="child.children.length === 0" (click)="setNavid(child.ID,child.MODULE,'',node)"
                routerLink="{{child.MODULE}}" class="primary-font" title="{{child.LABEL}}"><span>{{child.LABEL}}</span>
              </a>
              <ul *ngIf="child.children.length > 0">
                <li *ngFor="let gChild of child.children" routerLinkActive="active">
                  <a *ngIf="gChild.children.length === 0" (click)="setNavid(gChild.ID,gChild.MODULE,'',node)"
                    routerLink="{{gChild.MODULE}}" class="primary-font" title="{{gChild.LABEL}}"><span>{{gChild.LABEL}}</span>
                  </a>
                  <a *ngIf="gChild.children.length > 0" (click)="setNavid(gChild.ID,gChild.MODULE,'',node)" href="#"
                    class="primary-font" title="{{gChild.LABEL}}"><span>{{gChild.LABEL}}</span>
                  </a>
                  <ul *ngIf="gChild.children.length > 0">
                    <li *ngFor="let ggChild of gChild.children" routerLinkActive="active">
                      <a (click)="setNavid(ggChild.ID,ggChild.MODULE,'',node)" class="primary-font" title="{{ggChild.LABEL}}"
                        routerLink="{{ggChild.MODULE}}"><span>{{ggChild.LABEL}}</span></a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </ng-container>
    <!-- <aside-chat></aside-chat>   -->
    <div class="spin-loader" style="position: absolute;margin:auto;left:0;right:0" *ngIf="isNavLoading"></div>
  </nav>

  <sa-minify-menu></sa-minify-menu>
  <div class="navFooter" *ngIf="hasTicketRights">
    <div class="helpSection footer-menu pb-0 mb-3 pt-1">
      <hr class="hrColor">
      <sa-userticket *ngIf="hasTicketRights"></sa-userticket>
      <!-- <span  style="font-size: 14px;cursor: pointer;" >{{'invoice_dashboard_Helpdesk_Ticket' | i18n}}</span> -->
    </div>
  </div>

  <!-- User info -->
  <sa-login-info></sa-login-info>

  <!-- end user info -->
</aside>